import { useEffect, useRef, useState } from 'react'

import {
  useIsomorphicLayoutEffect,
  useMeasureObserver,
  useWindowSize,
} from '@unlikelystudio/react-hooks'

import { useCssVariables } from '~/providers/CssVariablesProvider'

import canUseDom from '~/utils/can-use-dom'

export default function use100vh() {
  if (!canUseDom) return

  const { height } = useWindowSize()
  const { update } = useCssVariables()

  useIsomorphicLayoutEffect(() => {
    update('vh-100', `${height}px`)
  }, [height])
}
